import clsx from 'clsx'

/**
 * The page header's buttons: `primary` for the page's main action, `secondary`
 * for the rest, `quiet` for a light link-like action, each with an icon-only
 * form. One height, so a header's actions line up.
 */
export type HeaderButtonVariant = 'primary' | 'secondary' | 'quiet'

const BASE =
  'inline-flex h-[var(--titlebar-control-size,32px)] shrink-0 items-center justify-center gap-1.5 rounded-md text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50'

const VARIANT: Record<HeaderButtonVariant, string> = {
  primary:
    'border border-[color:var(--action-brand-border)] bg-[color:var(--action-brand-bg)] text-[color:var(--action-brand-text)] hover:bg-[color:var(--action-brand-bg-hover)]',
  secondary:
    'border border-strong bg-[color:var(--surface-default)] text-subtle hover:bg-lighter hover:text-default',
  quiet: 'text-subtle hover:bg-muted hover:text-default',
}

/** The class for a header button, for elements that can't be `HeaderButton` (a picker's trigger). */
export function headerButtonClass(
  variant: HeaderButtonVariant = 'secondary',
  { iconOnly = false }: { iconOnly?: boolean } = {}
): string {
  return clsx(BASE, VARIANT[variant], iconOnly ? 'w-[var(--titlebar-control-size,32px)]' : 'px-3')
}
